export const TEMPORAL = "TEMPORAL";
export const CALCULATING = "CALCULATING";
export const DRAFT = "DRAFT";
export const CANCELLED = "CANCELLED";
export const APPROVED = "APPROVED";
export const IN_COURSE = "IN_COURSE";
export const DONE = "DONE";
